<template>
  <div class="app-container">
    <div>
      <p>{{ $t("common.download_template_excel") }}</p>
      <i class="fa fa-download" aria-hidden="true"></i>
      <a
        @click="exportExcelFile"
        >{{$t('common.exportFileExcel')}}</a
      >
    </div>
    <upload-excel-component
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
    />
    <!--  -->
    <b-table
      striped
      hover
      small
      :items="resultImportList"
      :fields="resultImportList_fields"
      class="mt-3"
      outlined
    >
      <template #head()="scope">
        <div>{{ $t(scope.label) }}</div>
      </template>
      <template #cell(statusImport)="row">
        <!-- {{row}} -->
        <p style="color:green" v-if="row.item.statusImport == importFromExcelEnum.PASS">
          {{ $t(getStatusImportExcel(row.item.statusImport)) }}
        </p>
        <p style="color:red" v-else-if="row.item.statusImport == importFromExcelEnum.ERROR">
          {{ $t(getStatusImportExcel(row.item.statusImport)) }}</p>
        <p style="color:blue" v-else-if="row.item.statusImport == importFromExcelEnum.EXISTS">
          {{ $t(getStatusImportExcel(row.item.statusImport)) }}
        </p>
      </template>
    </b-table>
    <div class="box-footer" v-if="isShowCheckCreateNewInvoice">
      <input
        type="checkbox"
        class="form-check-input"
        id="exampleCheck2"
        v-model="isCreateNewInvoice"
      />
      <label class="form-check-label" for="exampleCheck2">
        {{ $t('invoice.importExcel.isCreateNewInvoice') }}
      </label>
    </div>
    <div class="box-footer">
      <button
        id="cmdCancel"
        type="button"
        class="btn btn-default"
        @click="CancelList"
        style="margin-right: 5px;"
      >
        {{ $t("common.close") }}
      </button>
      <button
        v-if="isShowBtnConfirm"
        type="button"
        class="btn btn-primary pull-right"
        @click="onConfirm(isConfirmImport = true)"
      >{{$t('common.confirm')}}</button>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <!--  -->
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirmOverWrite"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
    <!--  -->
    <div
      class="modal fade"
      :ref="`modal-select-date-payment-invoice`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4
              class="modal-title"
            >
              {{ $t("invoice.datePaymentInvoice") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <!-- <date-picker
                  :placeholder="$t('invoice.einvoice.record_date')"
                  v-model="datePaymentInvoice"
                  :config="options"
                /> -->

                <div class="form-group">
                  <label>{{ $t('invoice.datePaymentInvoice') }}:</label>

                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <date-picker
                      :placeholder="$t('invoice.datePaymentInvoice')"
                      v-model="datePaymentInvoice" 
                      :config="options"></date-picker>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button type="button" class="btn btn-primary" @click="onConfirmSelectDatePaymentInvoice">
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  <!--  -->
  </div>
</template>

<script>
import UploadExcelComponent from "@/components/UploadExcel/index.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import LTEModal from "@/components/LTEModal.vue";
import utils from "@/lib/utils";
import ImportFromExcelEnum from "@/enum/importFromExcelEnum"

import { mapGetters, mapActions } from "vuex";
import XLSX from "xlsx";
import datePicker from "vue-bootstrap-datetimepicker";
import moment from 'moment';
export default {
  name: "ApartmentImportExcel",
  components: {
    UploadExcelComponent,
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    "lte-modal": LTEModal,
    "date-picker": datePicker
  },
  data() {
    return {
      // tableData: [],
      // tableHeader: [],
      hdBackground: "background-color: #4b646f;border:1px solid white;", //00a65a

      resultImportList: [], // Result import
      resultImportList_fields: [
        {
          key: "apartment_code",
          label: "apartment.apartment_code",
          sortable: true,
          class: "text-center"
        },
        {
          key: "statusImport",
          label: "common.status",
          sortable: true,
          class: "text-center"
        },
        {
          key: "errorDetail",
          label: "common.error",
          sortable: true,
          class: "text-center"
        }
      ],
      // import excel data
      importExcelData: {
        results: null,
        header: null
      },


      validateElement: {},
      invoiceType: null,
      isLoading: false,
      isCreateNewInvoice: false,
      isConfirmImport: false,
      isShowCheckCreateNewInvoice: false,
      isShowBtnConfirm: false,
      importFromExcelEnum: ImportFromExcelEnum,
      numberInvoiceExists: 0,
      objModal: [
        {
          title: "common.delete_modal.notiTitle",
          body: "invoice.importExcel.overWriteImportNoti",
          buttonNo: "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      isModalVisible: false,
      datePaymentInvoice: null,
      datePaymentInvoiceDefault: null,
      options: {
        format: "DD-MM-YYYY",
        useCurrent: false
      }
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    ...mapActions([
      "ON_SHOW_TOAST",
      "IMPORT_INVOICE_FROM_EXCEL"
    ]),
    getStatusImportExcel: function(value) {
      return utils.getStatusImportExcel(value)
    },
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (isLt1M) {
        return true;
      }

      this.$message({
        message: "Please do not upload files larger than 1m in size.",
        type: "warning"
      });
      return false;
    },
    CancelList: function() {
      this.$router.push({
        name: "InvoiceList",
        query: this.$route.query
      });
    },
    exportExcelFile: function() {
      let data_list = []
      let json_data = [
        {
          "Mã Căn": "0501",
          "Kỳ kế toán": "202103",
          "Mã code doanh thu": "270",
          "Chỉ số cũ": "25",
          "Chỉ số mới": "30",
          "Số tiêu thụ": "5",
          "Đơn giá": "22500",
          "Thành tiền": "112500",
          "% thuế GTGT (VAT)": "5",
          "Thuế GTGT (VAT)": "5625",
          "Tổng cộng": "118125",
          "Nợ đầu kỳ": "",
          "Diễn giải": "Tien nuoc tu 26/02 den 25/03/2021 can A05.01",
          "Nội dung thay đổi": ""
        },
        {
          "Mã Căn": "0501",
          "Kỳ kế toán": "202103",
          "Mã code doanh thu": "280",
          "Chỉ số cũ": "25",
          "Chỉ số mới": "30",
          "Số tiêu thụ": "5",
          "Đơn giá": "22500",
          "Thành tiền": "112500",
          "% thuế GTGT (VAT)": "5",
          "Thuế GTGT (VAT)": "5625",
          "Tổng cộng": "118125",
          "Nợ đầu kỳ": "",
          "Diễn giải": "Tien điện tu 26/02 den 25/03/2021 can A05.01",
          "Nội dung thay đổi": ""
        },
        {
          "Mã Căn": "0501",
          "Kỳ kế toán": "202103",
          "Mã code doanh thu": "290",
          "Chỉ số cũ": null,
          "Chỉ số mới": null,
          "Số tiêu thụ": null,
          "Đơn giá": null,
          "Thành tiền": "112500",
          "% thuế GTGT (VAT)": "5",
          "Thuế GTGT (VAT)": "5625",
          "Tổng cộng": "118125",
          "Nợ đầu kỳ": "",
          "Diễn giải": "Tien phí quản lý tu 26/02 den 25/03/2021 can A05.01",
          "Nội dung thay đổi": ""
        },
      ]

      data_list= json_data
      // export json to Worksheet of Excel
      // only array possible
      var invoiceFile = XLSX.utils.json_to_sheet(data_list);
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, invoiceFile, "invoiceFile"); // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

      // export Excel file
      XLSX.writeFile(wb, "invoiceFile.xlsx"); // name of the file is 'book.xlsx'
    },
    checkHeaderInExcelFile: function (headerInExcelFile) {
      let results = "OK"
      let headerRequired = [
        "Mã Căn", "Kỳ kế toán", "Mã code doanh thu", "Tổng cộng"
      ]
      let headerValidateArray = []
      for (let i=0, size=headerInExcelFile.length; i<size; i++){
        if (headerRequired.includes(headerInExcelFile[i].trim())){
          headerValidateArray.push(headerInExcelFile[i].trim())
        }
      }
      let arrayResult = headerRequired.filter(x => !headerValidateArray.includes(x));
      // for (let i=0, size=headerRequired.length; i < size; i++ ){
      //   if (headerInExcelFile.includes(headerRequired[i])===false) {
      //     results = this.$t('invoice.importExcel.notiNotFoundHeader', {'0': headerRequired[i]}) 
      //     break
      //   }
      // }
      if (arrayResult.length > 0) {
        results = this.$t('invoice.importExcel.notiNotFoundHeader', {'0': arrayResult[0]}) 
      }
      return results
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    handleSuccess({ results, header }) {
      let validateFile = this.checkHeaderInExcelFile(header)
      if (validateFile==="OK") {
        // 
        this.importExcelData.results = results
        this.importExcelData.header = header
        // this.tableData = results;
        this.isShowCheckCreateNewInvoice = false
        this.isShowBtnConfirm = false
        this.isConfirmImport = false
        this.isCreateNewInvoice = false
        this.datePaymentInvoice = null

        this.handleImportExcel()
        // this.tableHeader = header;
      } else {
        this.showError(validateFile)
      }
    },
    onConfirm: function() {
      // show modal confirm
      if (this.numberInvoiceExists > 0 && this.isConfirmImport && !this.isCreateNewInvoice) {
        this.isModalVisible = true;
      } else {
        this.onShowModalSelectDatePaymentInvoice()
        // this.handleImportExcel()
      }
    },
    handleImportExcel: function() {
      let data = {
        headers: this.importExcelData.header,
        dataImport: this.importExcelData.results,
        invoiceTypeImport: this.invoiceType,
        isConfirmImport: this.isConfirmImport,
        isCreateNewInvoice: this.isCreateNewInvoice,
        datePaymentInvoice: !utils.isEmptyString(this.datePaymentInvoice)
          ? moment(this.datePaymentInvoice + " 23:59:59", "DD-MM-YYYY hh:mm:ss").format('YYYY-MM-DD hh:mm:ss') : null
      };
      this.isLoading = true
      // init empty
      this.resultImportList = [];
      this.IMPORT_INVOICE_FROM_EXCEL(data)
        .then(
          function(res) {
            //{"status":"success","dataResult":[{"username":"user11595909","result":"PASS","error":"","type":"UPDATE"}]}

            res.dataResult.forEach(v => {
              let dataPass = {
                apartment_code: v.apartment_code,
                statusImport: v.result,
                errorDetail: v.error
              };
              this.resultImportList.push(dataPass);
            });
            this.numberInvoiceExists = res.number_invoice_exists
            if (res.number_invoice_exists > 0) {
              this.isShowCheckCreateNewInvoice = true
              this.isShowBtnConfirm = true
            } else {
              this.isShowCheckCreateNewInvoice = false
              this.isShowBtnConfirm = false
              if (this.datePaymentInvoice === null ) {
                this.onShowModalSelectDatePaymentInvoice()
              }
            }
            this.isLoading = false
          }.bind(this)
        )
        .catch(
          function() {
            let dataError = {
              apartment_code: "Unknown",
              statusImport: "FAIL",
              errorDetail: "Unknown"
            };

            this.resultImportList.push(dataError);
            this.isLoading = false
          }.bind(this)
        );
    },
    // 
    closeModal() {
      this.isModalVisible = false;
    },
    onConfirmOverWrite: function() {
      this.isModalVisible = false
      this.onShowModalSelectDatePaymentInvoice()
      // this.handleImportExcel()
    },
    onShowModalSelectDatePaymentInvoice: function() {
      this.datePaymentInvoice = this.datePaymentInvoiceDefault
      $(this.$refs[`modal-select-date-payment-invoice`]).modal("show");
    },
    onHideModalSelectDatePaymentInvoice: function() {
      $(this.$refs[`modal-select-date-payment-invoice`]).modal("hide");
    },
    onConfirmSelectDatePaymentInvoice: function() {
      if (!utils.isEmptyString(this.datePaymentInvoice)) {
        this.onHideModalSelectDatePaymentInvoice()
        this.isModalVisible = false
        this.isConfirmImport = true
        this.handleImportExcel()
      } else {
        this.showError('invoice.datePaymentInvoice')
      }
    }
  },
  mounted() {
    let invoiceType = this.$route.query.invoiceType
    if (!utils.isEmptyString(invoiceType)) {
      this.invoiceType = JSON.parse(invoiceType)
    }
    let toFormatDate = this.options.format
    let monthlyDueDate = sessionStorage.getItem('projectMonthlyDueDate')
    let projectDueDate = utils.formatSqlDate(monthlyDueDate, "DD", toFormatDate)
    this.datePaymentInvoiceDefault = projectDueDate
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Invoice/InvoiceImportExcel.vue